export const getDaySize = (viewportWidth) => {
  switch (true) {
    case viewportWidth <= 360:
      return 32;

    default:
      return 40;
  }
};
